// src/services/api.js
import axios from 'axios';

const API = axios.create({
   baseURL: process.env.REACT_APP_API_URL || 'https://totalassureplus.com/api',
 // baseURL: process.env.REACT_APP_API_URL ||'http://localhost:5000/api', 
});

export const UPLOADS_URL = `${API.defaults.baseURL}/uploads/`;

API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.method === 'get') {
        config.params = { ...config.params, _t: Date.now() };
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default API;